import api from './api';

export const fetchConvocations = (params) =>
  api.get('/convocations', { params }).then((r) => r.data);

export const fetchConvocationDetail = (gameId) =>
  api.get(`/convocations/${gameId}`).then((r) => r.data);
